import { TimeUtils } from '@front/volcanion/utils'
import { I18n } from '@front/volcanion'
class Callbacks {
  static afterChangeJobHandler(setFormValues, searchJob) {
    return async function afterChangeJob(job_id) {
      if (!!job_id) {
        const [job] = await searchJob({ job_id })
        const order = job?.first_step?.order

        const driver_options = _.map(order?.driver_opts, 'user_option_id')
        const vehicle_options = _.map(order?.vehicle_opts, 'vehicle_option_id')
        const vehicle_types = _.map(order?.commercial_package?.vehicletypes, 'vehicletype_id')

        const name = order?.service?.contract?.company?.name
        const requestedAt = TimeUtils.formatDateBackToFront(order?.requestedAt)
        const source_cp = order?.source?.postal_code

        const title = _.join(_.compact([_.upperCase(I18n.t('order.label', { count: 1 })), _.compact([name, requestedAt, source_cp]).join(' - ')]), ' ')

        setFormValues([
          { field: 'vehicle_options', value: vehicle_options },
          { field: 'driver_options', value: driver_options },
          { field: 'title', value: title },
          { field: 'cities', value: [order?.city] },
          { field: 'vehicletypes', value: vehicle_types }

        ])
      }
      else
        setFormValues([
          { field: 'vehicle_options', value: undefined },
          { field: 'driver_options', value: undefined },
          { field: 'title', value: undefined },
          { field: 'cities', value: undefined },
          { field: 'vehicletypes', value: undefined }
        ])
    }
  }
}

export default Callbacks
